import {PANELMANAGER_SHOW_DELETESUCCESSDIALOG} from '../../constants';

export type ShowDeleteSuccessDialogAction = {
    type : typeof PANELMANAGER_SHOW_DELETESUCCESSDIALOG;
    panelKey : string;
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 *
 * @return {ShowDeleteSuccessDialogAction}
 */
const showDeleteSuccessDialog = ( panelKey : string ) : ShowDeleteSuccessDialogAction => {
    return {
        type: PANELMANAGER_SHOW_DELETESUCCESSDIALOG,
        panelKey
    };
};
export type ShowDeleteSuccessDialog = typeof showDeleteSuccessDialog;

export default showDeleteSuccessDialog;
